function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { getAnimateDrawLineProps as i, getAnimateFadeInProps as s } from "../utils/animation.js";
import { useTheme as n } from "../hooks.js";
import { O2_SKIN as a, O2_CLASSIC_SKIN as m } from "../skins/constants.js";
import { vars as e } from "../skins/skin-contract.css-mistica.js";
import { outerAnimation as c, innerAnimation as l } from "./icon-error.css-mistica.js";
import { jsx as r, jsxs as t } from "../_virtual/jsx-runtime.js";
const d = ()=>{
    const { platformOverrides: o  } = n();
    return /* @__PURE__ */ r("svg", {
        width: "72",
        height: "64",
        viewBox: "0 0 72 64",
        children: /* @__PURE__ */ t("g", {
            stroke: e.colors.error,
            fill: e.colors.error,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                /* @__PURE__ */ t("g", {
                    className: c,
                    children: [
                        /* @__PURE__ */ r("path", _objectSpread({
                            strokeWidth: "2",
                            fill: "none",
                            d: "M48.24,57.99c-4.71,2.95-10.27,4.65-16.24,4.65C15.08,62.64,1.36,48.92,1.36,32S15.08,1.36,32,1.36 S62.64,15.08,62.64,32c0,6.11-1.79,11.8-4.87,16.58"
                        }, i("202", "0.3s", o))),
                        /* @__PURE__ */ r("circle", _objectSpread({
                            cx: "53.64",
                            cy: "53.54",
                            r: "1.06"
                        }, s("0.2s", o)))
                    ]
                }),
                /* @__PURE__ */ t("g", {
                    className: l,
                    children: [
                        /* @__PURE__ */ r("line", _objectSpread({
                            strokeWidth: "2",
                            fill: "none",
                            x1: "32",
                            y1: "14.86",
                            x2: "32",
                            y2: "39.08"
                        }, i("110", "0.6s", o))),
                        /* @__PURE__ */ r("circle", _objectSpread({
                            strokeWidth: "0",
                            cx: "32",
                            cy: "46.25",
                            r: "1.72"
                        }, s("0.8s", o)))
                    ]
                })
            ]
        })
    });
}, h = ()=>{
    const { platformOverrides: o  } = n();
    return /* @__PURE__ */ r("svg", {
        width: "72",
        height: "64",
        viewBox: "0 0 72 64",
        children: /* @__PURE__ */ t("g", {
            stroke: e.colors.error,
            fill: "none",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            children: [
                /* @__PURE__ */ r("g", {
                    className: c,
                    children: /* @__PURE__ */ r("path", _objectSpread({
                        fill: "none",
                        strokeWidth: "2",
                        strokeMiterlimit: "10",
                        d: "M 31.9 0.9 C 52.5 0.9 62.9 11.4 62.9 31.9 C 62.9 52.5 52.5 62.9 31.9 62.9 C 11.3 62.9 0.9 52.5 0.9 31.9 C 0.9 11.3 11.3 0.9 31.9 0.9 Z",
                        transform: "rotate(90 32 32)"
                    }, i("202", "0.3s", o)))
                }),
                /* @__PURE__ */ t("g", {
                    className: l,
                    children: [
                        /* @__PURE__ */ r("line", _objectSpread({
                            x1: "31.9",
                            y1: "20.9",
                            x2: "31.9",
                            y2: "36.9"
                        }, i("17", "0.7s", o))),
                        /* @__PURE__ */ r("circle", _objectSpread({
                            stroke: e.colors.error,
                            fill: e.colors.error,
                            strokeWidth: "1",
                            cx: "31.9",
                            cy: "43.9",
                            r: "1.5"
                        }, s("1s", o)))
                    ]
                })
            ]
        })
    });
}, v = ()=>{
    const { skinName: o  } = n();
    return o === a || o === m ? /* @__PURE__ */ r(d, {}) : /* @__PURE__ */ r(h, {});
};
export { v as default };
